import Popup from 'reactjs-popup'
import React from 'react'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { HeaderDropdown, HeaderDropdownItemL } from './HeaderDropdown'

export default function MaskDropdown({ trigger, position, contentStyle }) {
	const pex = useSelector((state) => state.user.value.pex)

	return (
		<Popup
			trigger={trigger}
			position={position}
			on='click'
			closeOnDocumentClick
			mouseLeaveDelay={300}
			mouseEnterDelay={0}
			contentStyle={contentStyle}
			arrow={false}
		>
			<HeaderDropdown>
				{pex.read_owner && (
					<HeaderDropdownItemL to='/inputMask/owner'>
						Besitzer
					</HeaderDropdownItemL>
				)}
				{pex.read_artist && (
					<HeaderDropdownItemL to='/inputMask/artist'>
						Künstler
					</HeaderDropdownItemL>
				)}
				{pex.read_artwork && (
					<HeaderDropdownItemL to='/inputMask/artwork'>
						Werke
					</HeaderDropdownItemL>
				)}
				{pex.read_artwork && (
					<HeaderDropdownItemL to='/filterartwork'>Suchen</HeaderDropdownItemL>
				)}
			</HeaderDropdown>
		</Popup>
	)
}
